import { ContentHeader } from '@components';
import { Row, Col, Skeleton } from 'antd';
import SkeletonInput from 'antd/lib/skeleton/Input';

const LoadingDashboardPage = () => {
    return (
        <div>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mt-2 mb-2">
                        <div className="col-sm-6">
                            <SkeletonInput active />
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <Row className="form-group" gutter={16}>
                    <Col span="12" style={{ color: "#071C50" }}>
                        <div className="card">
                            <Row align="middle">
                                <Col span="8">
                                    <Row justify="center">
                                        <Col span="12">
                                            <div style={{ width: "100%" }}>
                                                <Skeleton.Image />
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span="16 pt-3 pr-2">
                                    <Skeleton active paragraph={{ rows: 8 }} />
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span="12">
                        <Row gutter={16}>
                            <Col span="12">
                                <div className="card card-body">
                                    <Skeleton active />
                                </div>
                            </Col>
                            <Col span="12">
                                <div className="card card-body">
                                    <Skeleton active />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <div className="card card-body">
                                    <Skeleton active paragraph={{ rows: 1 }} />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    
                </Row>
                <Row gutter={16} className="mt-4">
                    <Col span="16">
                        <Skeleton active paragraph={{ rows: 0 }} />
                        <div className="card card-body">
                            <Skeleton active paragraph={{ rows: 8 }} />
                        </div>
                    </Col>
                    <Col span="8">
                        <Skeleton active paragraph={{ rows: 0 }} />
                        <div className="card card-body">
                            <Skeleton active paragraph={{ rows: 8 }} />
                        </div>
                    </Col>
                </Row>
            {/*    <Row className="form-group" gutter={16}>*/}
            {/*        <Col span="16">*/}
            {/*            <b style={{ fontSize: "20px", color: "#071C50" }}>Thống kê độ tuổi</b>*/}
            {/*            <div className="card mt-2" style={{ height: "400px" }}>*/}
            {/*                <div className="card-body">*/}
            {/*                    <Bar data={dataTuoiTac} options={options} height={"100%"} />*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </Col>*/}
            {/*        <Col span="8">*/}
            {/*            <b style={{ fontSize: "20px", color: "#071C50" }}>Trình độ</b>*/}
            {/*            <div className="card mt-2" style={{ height: "400px", display: "flex", justifyContent: "center", alignItems: "center" }}>*/}
            {/*                <div className="card-body">*/}
            {/*                    <Doughnut data={dataTrinhDo} style={{ marginLeft: "20px" }} options={options} />*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </Col>*/}
            {/*    </Row>*/}
            </section>
        </div>
    );
};

export default LoadingDashboardPage;
